import { render, staticRenderFns } from "./order_cancellation_reasons.vue?vue&type=template&id=22380f88&scoped=true&"
import script from "./order_cancellation_reasons.vue?vue&type=script&lang=js&"
export * from "./order_cancellation_reasons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22380f88",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/brisk/brisk-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('22380f88')) {
      api.createRecord('22380f88', component.options)
    } else {
      api.reload('22380f88', component.options)
    }
    module.hot.accept("./order_cancellation_reasons.vue?vue&type=template&id=22380f88&scoped=true&", function () {
      api.rerender('22380f88', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/fields/dropdown/order_cancellation_reasons.vue"
export default component.exports